export default __webpack_public_path__ + "static/media/VIDEOS.bd861508.png";